import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { alignmentConverterMap } from './alignmentPropsToCss'

/**
 * Enriches the converters registry with all alignment style property converters.
 * Includes converters for both CSS align-self and align-items properties with baseline and positional alignment values.
 */
export function enrichAlignmentConverters(): void {
	// Register all alignment converters by their type discriminants
	// Single converter map handles both AlignSelf and AlignItems types
	Object.entries(alignmentConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
